import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-azelaic-acid',
  imports: [UpsellCardComponent],
  templateUrl: './azelaic-acid.component.html',
  styleUrl: './azelaic-acid.component.scss',
})
export class AzelaicAcidComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.AzelaicAcid;
}
